module.exports = __webpack_public_path__ + "img/TRACTEBEL.16600951.jpg";